import { useAuthStore } from "@/store/useAuthStore";
import Home from "./Home";
import StaffDashboard from "./StaffDashboard";

// `/` for every role. Owner and viewer get the full dashboard; a manager or
// supervisor gets the no-money view (the full summary is refused to them).
export default function DashboardEntry() {
  const role = useAuthStore((s) => s.user?.role);
  return role === "manager" || role === "supervisor" ? <StaffDashboard /> : <Home />;
}
